import { render } from "./TermsAndConditions.vue?vue&type=template&id=363a762d&lang=pug"
import script from "./TermsAndConditions.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&setup=true&lang=js"

import "./TermsAndConditions.vue?vue&type=style&index=0&id=363a762d&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__